<div class="dashboardActionHeading__procurationDataElement" style="display: unset;">
    <p class="dashboardActionHeading__procurationDataLabel  personData__label"
        style="font-size: 14px; margin-bottom: 0px;">
        {{label}} </p>
    <p class="dashboardActionHeading__procurationDataValue mr-0" style="font-size: 18px;">
        {{value}}
    </p>
</div>